import { render, staticRenderFns } from "./Observatii_devize_dialog.vue?vue&type=template&id=4e3a51e2&scoped=true&"
import script from "./Observatii_devize_dialog.vue?vue&type=script&lang=js&"
export * from "./Observatii_devize_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Observatii_devize_dialog.vue?vue&type=style&index=0&id=4e3a51e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a51e2",
  null
  
)

export default component.exports